import { app } from '@/main'
import { sideMenuMap, routerMap } from './routerMap'
import { setStorage, getStorage, deepCopy } from '@GUTIL/other'

const cacheMenus = getStorage('menu')

const state = {
  sideMenu: cacheMenus ? cacheMenus : [],
  isSideMenuLoading: false,
  iconTheme: 'outlined'
}

const actions = {
  async [_GM.SET_SIDE_MENU_PROMPT](
    { commit, rootState },
    { index, promptApi }
  ) {
    let graphProvider =
      rootState.Global.folderName == 'operator'
        ? app.$operatorGraphqlProvider
        : app.$departmentGraphqlProvider
    if (getStorage('access_token')) {
      const data = await graphProvider[promptApi]()
      commit('SET_SIDE_MENU_PROMPT', {
        index,
        count: data[promptApi]
      })
    }
  }
}

const mutations = {
  [_GM.RESET_SIDE_MENU](state) {
    state.sideMenu = []
  },
  [_GM.SET_SIDE_MENU_LOADING](state, payload) {
    state.isSideMenuLoading = payload
  },
  [_GM.SET_SIDE_MENU](state, payload) {
    let { folderName, allowedMenuIds } = payload
    let currentMenuMap = deepCopy(sideMenuMap[folderName])
    let matchMenu = currentMenuMap.filter(menu => {
      // if menu has subset, only check subset.id is in allowedMenuIds
      if (menu.subset && menu.subset.length > 0) {
        menu.subset = menu.subset.filter(
          subMenu => allowedMenuIds.indexOf(subMenu.id) >= 0
        )
        return menu.subset.length > 0
      } else {
        return allowedMenuIds.indexOf(menu.id) >= 0
      }
    })
    setStorage('menu', matchMenu)
    state.sideMenu = matchMenu
  },
  [_GM.SET_SIDE_MENU_PROMPT](state, payload) {
    let { index, count } = payload
    state.sideMenu[index].prompt.count = count
    setStorage('menu', state.sideMenu)
  },
  [_GM.SET_ICON_THEME](state, payload) {
    state.iconTheme = payload
  }
}

const getters = {
  isSideMenuLoading: state => state.isSideMenuLoading,
  sideMenu: state => state.sideMenu,
  iconTheme: state => state.iconTheme,
  routeName: (state, getters, rootState) => menuId =>
    routerMap[rootState.Global.folderName][menuId]
}

export default {
  state,
  actions,
  mutations,
  getters
}
